// /**
//  * parcel - Add
//  */

// React
import React, { useEffect, useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';
import handleNotfication from '../../..//utils/handleNotfication';
// UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  FormControl,
  FormHelperText,
  Divider,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import partnerRepository from 'client-sdk/src/Repository/partners-repository';

// Icon
import Icon from '@mdi/react';
import { mdiPaperclip } from '@mdi/js';

// Client SDK
import InvoicesRepository from 'client-sdk/src/Repository/invoices-repository';

// Type
import { AddItemCreateParcel } from '../../parcels/interfaces';

// helpers'
import handleError from '../../../utils/handleError';
import theme from '../../../theme';

type Props = {
  addItem: (body: AddItemCreateParcel) => void;
  fulfillmentService: boolean;
  fulfillmentLineId: number;
  onClose: () => void;
  editId: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& MuiDialogActions-root': {
        paddingBottom: 'none',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      width: '90%',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    cancelTitle: {
      width: '100%',
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();
  const { register, handleSubmit, errors, reset } =
    useForm({
      defaultValues: {
        amount: ' ',
        subject: '',
        partner: ' ',
        file: null,
        damageCost: '',
        insuranceCost: ''
      },
    });

  const [partnersLoading, setPartnersLoading] = useState<boolean>(false);
  const [partner, setPartner] = useState([]);
  const [partners, setPartners] = useState<any>([]);
  const [file, setFile] = useState<any>(null);
  const [detailFile, setDetailFile] = useState<any>(null);

  useEffect(() => {
    getPartners({ size: 2000 });
  }, []);

  useEffect(() => {
    if (partners.length > 0 && props.type == 'edit') {
      const compeletPartner = partners.filter((item: any) => {
        return item.name === props.data.partnerName;
      });
      const sub = decodeURI(props.data?.subject);
      reset({
        amount: props.data?.amount,
        subject: sub,
        partner: compeletPartner?.[0],
        damageCost: props.data.damageCost,
        insuranceCost: props.data.insuranceCost
      });
      setPartner(compeletPartner?.[0]);
      // setSubject(props.data?.subject);
      setFile({ file: null, name: props.data.fileName });
      setDetailFile({ file: null, name: props.data.detailFileName });
    }
  }, [props.data, partners]);

  const onSubmit = async (data: any) => {
    try {
      if (props.type === 'edit') {
        updateInvoice(data)
      } else {
        createInvoice(data)
      }
    } catch (err) {
      handleError(err.response);
    }
  };

  const uploadInvoice = async (id: string) => {
    const invoice = new FormData();
    invoice.append('file', file);
    try {
      await InvoicesRepository.uploadInvoiceFiles({
        payload: {
          data: invoice,
          type: "RECEIPT",
          id: id
        }
      })
    } catch (error) {
      handleNotfication("مشکلی در آپلود فایل فاکتور وجود دارد.","error")
    }
  }

  const uploadDetail = async (id: string) => {
    const invoiceDetail = new FormData();
    invoiceDetail.append('file', detailFile);
    try {
      await InvoicesRepository.uploadInvoiceFiles({
        payload: {
          data: invoiceDetail,
          type: "DETAIL",
          id: id
        }
      })
    } catch (error) {
      handleNotfication("مشکلی در آپلود فایل جزئیات فاکتور وجود دارد.","error") 
    }
  }

  const createInvoice = async (data: any) => {
    const { subject, amount, insuranceCost, damageCost } = data;
    const creatorId = localStorage.getItem('userId') || '';
    const sub = encodeURI(subject);
    try {
      const response = await InvoicesRepository.createInvoice({
        payload: {
          body: {
            partnerId: partner.id,
            creatorId,
            subject: sub,
            amount,
            damageCost,
            insuranceCost
          },
        },
      });
      file?.size && uploadInvoice(response.data.id)
      detailFile?.size && uploadDetail(response.data.id)
      handleNotfication("فاکتور با موفقیت ساخته شد.", "success")
      props.onClose();
    } catch (error) {
      handleError(error)
    }
  }

  const updateInvoice = async (data: any) => {
    const { subject, amount, insuranceCost, damageCost } = data;
    const creatorId = localStorage.getItem('userId') || '';
    const sub = encodeURI(subject);
    try {
      const response = await InvoicesRepository.updateInvoice({
        payload: {
          body: {
            partnerId: partner.id,
            creatorId,
            subject: sub,
            amount,
            id: props.editId,
            insuranceCost,
            damageCost
          },
        },
      });
      file?.size && uploadInvoice(response.data.id)
      detailFile?.size && uploadDetail(response.data.id)
      handleNotfication("فاکتور با موفقیت ویرایش شد.", "success")
      props.onClose();
    } catch (error) {
      handleError(error)
    }
  }

  const getPartners = async (actions: any) => {
    const payload = { ...actions };

    try {
      setPartnersLoading(true);
      const { response, count } = await partnerRepository.getPartners({ payload });
      setPartners([
        ...response.data.map((partner: any) => {
          return {
            id: partner.id,
            name: partner.name,
          };
        }),
      ]);
    } catch (error) {
      handleNotfication(error.message, 'error');
    } finally {
      setPartnersLoading(false);
    }
  };
  const handleChangeFileInput = (event: any) => {
    if (event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };
  const handleChangeDetailFileInput = (event: any) => {
    if (event.target.files[0]) {
      setDetailFile(event.target.files[0]);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          style={{ paddingBottom: '0' }}
        >
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <span style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    getOptionSelected={(option, value) =>
                      option.name === value?.name
                    }
                    getOptionLabel={option => option.name}
                    options={partners}
                    value={partner}
                    loading={partnersLoading}
                    onChange={(event: any, newValue: any) => {
                      setPartner(newValue);
                    }}
                    renderInput={params => (
                      <TextField
                        variant="outlined"
                        {...params}
                        label="نام شرکت"
                        inputRef={register({
                          required: true,
                        })}
                        name="partner"
                        id="partner"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {partnersLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </FormControl>
              </span>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="subject"
                  name="subject"
                  label="بابت"
                  inputRef={register({ required: true })}
                  error={errors.subject}
                  autoFocus
                />
                <FormHelperText error focused>
                  {errors.subject && 'فیلد بابت الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="amount"
                  name="amount"
                  label="مبلغ نهایی فاکتور (ریال)"
                  inputRef={register({ required: true })}
                  error={errors.amount && true}
                />
                {/* <FormHelperText error focused>
                , pattern: /[0-9]/ 
                  {errors.amount?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText> */}
                <FormHelperText error focused>
                  {errors.amount?.type === 'required' && 'مبلغ الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="damageCost"
                  name="damageCost"
                  label="خسارت"
                  inputRef={register({ required: false })}
                  error={errors.damageCost && true}
                />
                {/* <FormHelperText error focused>
                , pattern: /[0-9]/ 
                  {errors.damageCost?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText> */}
                <FormHelperText error focused>
                  {errors.damageCost?.type === 'required' && 'مبلغ الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  fullWidth
                  id="insuranceCost"
                  name="insuranceCost"
                  label="بیمه"
                  inputRef={register({ required: false })}
                  error={errors.insuranceCost && true}
                />
                {/* <FormHelperText error focused>
                , pattern: /[0-9]/ 
                  {errors.insuranceCost?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText> */}
                <FormHelperText error focused>
                  {errors.insuranceCost?.type === 'required' && 'مبلغ الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div className={classes.cancelTitle}>
                <TextField
                  id="file"
                  name="file"
                  variant="outlined"
                  size="small"
                  label={file?.name ? file.name : 'فایل فاکتور'}
                  className={classes.textInput}
                  // value={fileName}
                  disabled
                />
                <IconButton component="label" title="آپلود فایل">
                  <Icon
                    color={theme.palette.secondary.main}
                    path={mdiPaperclip}
                    size={1}
                  />
                  {/* <label htmlFor="file" className={classes.labelInput}>
                    <Typography>
                      {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                    </Typography> */}
                  <input
                    type="file"
                    name="file"
                    onChange={handleChangeFileInput}
                    onClick={(e: React.ChangeEvent<{ value: unknown }>) =>
                      (e.target.value = null)
                    }
                    hidden
                  />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Grid container item xs={12} md={12} alignItems="flex-end">
            <div className={classes.item}>
              <div className={classes.cancelTitle}>
                <TextField
                  id="detailFile"
                  name="detailFile"
                  variant="outlined"
                  size="small"
                  label={detailFile?.name ? detailFile.name : 'فایل جزئیات فاکتور'}
                  className={classes.textInput}
                  // value={fileName}
                  disabled
                />
                <IconButton component="label" title="آپلود فایل">
                  <Icon
                    color={theme.palette.secondary.main}
                    path={mdiPaperclip}
                    size={1}
                  />
                  {/* <label htmlFor="file" className={classes.labelInput}>
                    <Typography>
                      {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                    </Typography> */}
                  <input
                    type="file"
                    name="detailFile"
                    onChange={handleChangeDetailFileInput}
                    onClick={(e: React.ChangeEvent<{ value: unknown }>) =>
                      (e.target.value = null)
                    }
                    hidden
                  />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Divider
            style={{
              margin: '10px auto 15px auto',
              width: '97%',

              alignItems: 'center',
            }}
          />
          <Grid container md={12} style={{ padding: '0 7px' }}>
            <Grid
              container
              item
              md={12}
              style={{
                alignItems: 'center',
                marginBottom: '-2px',
                paddingBottom: '0',
              }}
            >
              <Button
                style={{ marginRight: 'auto' }}
                type="submit"
                size="large"
                data-cy="submitAddProduct"
                autoFocus
                variant="contained"
                color="primary"
                // disabled={!inputValueProduct}
                fullWidth
              >
                {'تایید و ارسال'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
